import * as $ from 'jquery';

/**
 * GlossaryJumpToAnchorController
 *
 * @author Marcel Arndt <m.arndt@andersundsehr.com>
 */
export default class GlossaryJumpToAnchorController {
  private jumpToAnchorItemSelector = '.js-jumpToAnchor';

  /**
   * Public function to init class
   */
  constructor() {
    this.addJumpToAnchorClickListener();
  }

  addJumpToAnchorClickListener() {
    const $items = $(this.jumpToAnchorItemSelector);
    $items.on('click', (event) => {
      const $anchor = $(event.currentTarget).attr('href');
      this.scrollToAnchor($anchor);
    });
  }

  scrollToAnchor($anchor) {
    const anchorOffset = $($anchor).offset();
    if (anchorOffset) {
      $('html,body').animate({
        scrollTop: anchorOffset.top - 120 || 0,
      });
    }
  }
}
